export default __webpack_public_path__ + "static/media/forums-icon.1f2340fb.svg";